import styled from 'styled-components'

export const TitleWrapper = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	column-gap: 12px;
`
